<template>
  <router-link :id="$attrs['id']"
               :to="{ name: link, params: params }"
               :exact="exact"
               tag="li"
               active-class="item-nav__li--active"
               class="item-nav__li">
    <a href="javascript:void(0);" class="item-nav__link">
      <span class="item-nav__link__label">{{ label }}<div v-if="beta" class="item-nav__badge">{{ $t('betaVersion.title') }}</div></span>
    </a>
  </router-link>
</template>

<script>

export default {
  name: 'ItemNavItem',

  props: {
    link: {},
    label: {},
    params: {},
    beta: {},
    alpha: {},
    exact: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // @import '~styles/main';
  @import '~styles/components/lib/ItemNav';

  .item-nav__badge {
    background-color: $mint;
    position: absolute;
    line-height: 1;
    top: 10px;
    right: 16px;
    padding: 8px 16px;
    border-radius: 16px;
    color: white;
    font-weight: bold;
    white-space: nowrap;
    transform: rotate(0deg);
  }

</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/ItemNavItem.vue